module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "width": _vm.modelWidth,
      "mask-closable": false,
      "class-name": "new-modal"
    },
    on: {
      "on-cancel": _vm.cancel
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.type == 'info') ? _c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#02cad6"
    }
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), (_vm.type == 'success') ? _c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#48bb9b"
    }
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), (_vm.type == 'warning') ? _c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#02cad6"
    }
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), (_vm.type == 'confirm') ? _c('i', {
    staticClass: "iconfont icon",
    staticStyle: {
      "color": "#02cad6"
    }
  }, [_vm._v("")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.messageInfo)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isConfirm) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onOk
    }
  }, [_vm._v(_vm._s(_vm.okBtnText))]) : _vm._e(), _vm._v(" "), (_vm.isConfirm) ? _c('Button', {
    staticClass: "confirmBtn cancel",
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnText))]) : _vm._e(), _vm._v(" "), (_vm.isConfirm) ? _c('Button', {
    staticClass: "confirmBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onOk
    }
  }, [_vm._v(_vm._s(_vm.okBtnText))]) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7da5a9c3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da5a9c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/new-modal.vue
// module id = 1372
// module chunks = 61